"use client";

import { Button } from "../../";
import { ScrollArea, ScrollBar } from "../../";
import { cn } from "../../utils";
import type { ComponentProps } from "react";

export type SuggestionsProps = ComponentProps<typeof ScrollArea>;

export const Suggestions = ({ className, children, ...props }: SuggestionsProps) => (
  <ScrollArea className="al-w-full al-overflow-x-auto al-whitespace-nowrap" {...props}>
    <div className={cn("al-flex al-w-max al-flex-nowrap al-items-center al-gap-2", className)}>
      {children}
    </div>
    <ScrollBar className="al-hidden" orientation="horizontal" />
  </ScrollArea>
);

export type SuggestionProps = Omit<ComponentProps<typeof Button>, "onClick"> & {
  suggestion: string;
  onClick?: (suggestion: string) => void;
};

export const Suggestion = ({
  suggestion,
  onClick,
  className,
  variant = "outline",
  size = "sm",
  children,
  ...props
}: SuggestionProps) => {
  const handleClick = () => {
    onClick?.(suggestion);
  };

  return (
    <Button
      className={cn("al-cursor-pointer al-rounded-full al-px-4", className)}
      onClick={handleClick}
      size={size}
      type="button"
      variant={variant}
      {...props}
    >
      {children || suggestion}
    </Button>
  );
};
